/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  ModalBody,
  Modal,
  ModalHeader,
  ModalFooter,
  Spinner,
  Form,
  FormGroup,
  Input,
  Label,
  Container
} from "reactstrap";
import { withRouter } from "react-router-dom";
// import FileUpload from "./FileUpload";
import DragImage from "../../common/dragImage";
import "./index.style.scss";
import DraftEditor from "../../common/DraftEditor";
import firebase from "../../../config/firebase";
import { toast } from "react-toastify";
import { isImageValid, resizeFile, resourceIsValid } from "./resourcesUtils";
import ResourcePreview from "./ResourcePreview";

class AddNewResource extends PureComponent {
  constructor() {
    super();
    this.resourcePath = "https://heyremote.io/resources/";
    this.state = {
      resources: [1, 2, 3],
      loading: false,
      modal: false,
      pageLink: "",
      pageTitle: "",
      pageMetaDescription: "",
      title: "",
      content: "",
      featureImage: "",
      imageLabel: "",
      emptyFields: {},
      imageRaw: "",
      clearInputs: false,
      error: {},
      isOpen: false
    };
  }

  onChangeHandler = e => {
    if (e.target.name === "pageLink") {
      console.log({ et: e.keyCode, value: e.target.value, e });
      // if (e.target.value.length < 1) {
      //   this.setState({ pageLink: this.resourcePath });
      // } else {
      let value =
        e.target.value.indexOf(this.resourcePath) === -1
          ? e.target.value
          : e.target.value.replace(this.resourcePath, "");
      this.setState({ pageLink: value });
      // }
    } else
      this.setState({
        [e.target.name]: e.target.value
      });
  };

  onChangePageLink = e => {
    // if (e.target.name === "pageLink") {
    console.log({ et: e.keyCode, value: e.target.value, e: e.target });
    // if (e.target.value.length < 1) {
    //   this.setState({ pageLink: this.resourcePath });
    // } else {
    let value =
      e.target.value.indexOf(this.resourcePath) === -1
        ? e.target.value
        : e.target.value.replace(this.resourcePath, "");
    this.setState({ pageLink: value });
    // }
  };

  onImageChangeHandler = async event => {
    // const file = event.target.files[0];
    const file = event.target.files[0];
    if (isImageValid(file)) {
      const image = await resizeFile(file);
      console.log({ image });
      this.setState({
        featureImage: image,
        imageLabel: file.name,
        imageRaw: file
      });
    }
  };

  // Image Drop Handler.
  handleDrop = async files => {
    // console.log(files);
    const file = files[0];
    if (isImageValid(file)) {
      const image = await resizeFile(file);
      console.log({ image });
      this.setState({
        featureImage: image,
        imageLabel: file.name,
        imageRaw: file
      });
    }
  };

  //   Setting Editor returned HTML of Content
  handleContentChange = value => {
    this.setState({ content: value });
  };

  //   upload Image on Firestore
  uploadResourceImage = async (file, companyEmail) => {
    console.log("upload called----", file);
    const storageRef = firebase.storage().ref();
    const fileRef = storageRef.child(
      `resources/${new Date().toUTCString()}-${this.state.imageRaw.name}`
    );
    await fileRef.put(file);
    return fileRef.getDownloadURL();
  };

  //   On Submit Resource
  onSubmitHandler = async stat => {
    this.setState({ error: {} });
    let {
      pageLink,
      pageMetaDescription,
      pageTitle,
      title,
      content,
      featureImage,
      imageRaw
    } = {
      ...this.state
    };
    pageLink = this.resourcePath + pageLink;
    let requiredFields = {
      pageLink,
      pageMetaDescription,
      pageTitle,
      title,
      featureImage,
      content
    };
    let validationErrors = resourceIsValid(requiredFields);
    console.log({ validationErrors });
    if (validationErrors === null) {
      this.setState({ loading: true });
      console.log({ requiredFields });
      let status = stat === "saveToDraft" ? "saved" : "published";
      let imageUrl = await this.uploadResourceImage(featureImage);
      console.log({ imageUrl });
      let db = firebase.firestore().collection("resources");
      let resourceRef = db.doc();
      console.log({ db, resourceRef });
      requiredFields.uploadedAt = firebase.firestore.FieldValue.serverTimestamp();
      if (status === "published")
        requiredFields.publishedAt = firebase.firestore.FieldValue.serverTimestamp();
      db.doc(resourceRef.id)
        .set({
          id: resourceRef.id,
          ...requiredFields,
          pageLink: `${pageLink}-${resourceRef.id}`,
          featureImage: {
            url: imageUrl,
            name: imageRaw.name
          },
          status
        })
        .then(res => {
          this.clearForm();
          toast.success(`Resource ${status} successfully. `);
          this.props.onSubmitResource();
        })
        .catch(error => {
          toast.error(error.message);
          console.error(error);
        });
    } else this.setState({ error: validationErrors });
  };

  clearForm = () => {
    this.setState({
      pageLink: "",
      pageTitle: "",
      pageMetaDescription: "",
      title: "",
      content: "",
      featureImage: "",
      imageLabel: "",
      emptyFields: {},
      imageRaw: "",
      loading: false,
      clearInputs: true
    });
  };

  toggleModal = () => this.setState(({ isOpen }) => ({ isOpen: !isOpen }));

  render() {
    const {
      resources,
      loading,
      pageLink,
      pageTitle,
      pageMetaDescription,
      title,
      content,
      featureImage,
      imageLabel,
      emptyFields,
      error
    } = this.state;
    return (
      <Col md={12} lg={12}>
        {/* Preview Modal */}
        <Modal
          isOpen={this.state.isOpen}
          toggle={this.toggleModal}
          style={{ maxWidth: "1020px" }}
        >
          <ModalHeader toggle={this.toggleModal}>Preview</ModalHeader>
          <ModalBody>
            <ResourcePreview resource={{ title, featureImage, content }} />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleModal} size="sm">
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        {/* <Container> */}
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">Upload New Resource</h5>
              {/* <h5 className="subhead">For files upload</h5> */}
            </div>
            <form>
              <Row>
                <Col md={12}>
                  <Label htmlFor="_pageLink">
                    Page Link <span className="required-dot">•</span>{" "}
                  </Label>
                  <Input
                    name="pageLink"
                    value={this.resourcePath + pageLink}
                    id="_pageLink"
                    onChange={this.onChangeHandler}
                    // onKeyDown={this.onChangePageLink}
                    className={
                      error?.emptyFields?.hasOwnProperty("pageLink")
                        ? "emptyInput"
                        : ""
                    }
                  />

                  {error.pageLink && (
                    <p style={{ color: "red" }}>{error.pageLink}</p>
                  )}
                </Col>
                <Col md={6}>
                  <Label htmlFor="_pageTitle">
                    Page Title <span className="required-dot">•</span>{" "}
                  </Label>
                  <Input
                    name="pageTitle"
                    value={pageTitle}
                    id="_pageTitle"
                    className={
                      error?.emptyFields?.hasOwnProperty("pageTitle")
                        ? "emptyInput"
                        : ""
                    }
                    onChange={this.onChangeHandler}
                  />
                  {error.pageTitle && (
                    <p style={{ color: "red" }}>{error.pageTitle}</p>
                  )}
                </Col>
                <Col md={6}>
                  <Label htmlFor="_pageMetaDescription">
                    Page Meta Description{" "}
                    <span className="required-dot">•</span>{" "}
                  </Label>
                  <Input
                    name="pageMetaDescription"
                    value={pageMetaDescription}
                    id="_pageMetaDescription"
                    className={
                      error?.emptyFields?.hasOwnProperty("pageMetaDescription")
                        ? "emptyInput"
                        : ""
                    }
                    onChange={this.onChangeHandler}
                  />
                  {error.pageMetaDescription && (
                    <p style={{ color: "red" }}>{error.pageMetaDescription}</p>
                  )}
                </Col>
                <Col md={12}>
                  <Label htmlFor="_title">
                    Title <span className="required-dot">•</span>{" "}
                  </Label>
                  <Input
                    name="title"
                    value={title}
                    id="_title"
                    className={
                      error?.emptyFields?.hasOwnProperty("title")
                        ? "emptyInput"
                        : ""
                    }
                    onChange={this.onChangeHandler}
                  />
                </Col>
                <Col md={12}>
                  <div className="input-container">
                    <label>
                      Image <span className="required-dot">•</span>{" "}
                      <span
                        id="__companyLogoError"
                        style={{ color: "red", marginLeft: "10px" }}
                      ></span>
                    </label>
                    <DragImage handleDrop={this.handleDrop}>
                      <div
                        className={`company-logo-dragger ${
                          error?.emptyFields?.hasOwnProperty("featureImage")
                            ? "emptyInput"
                            : ""
                        }`}
                      >
                        <input
                          type="file"
                          name="featureImage"
                          id="featureImage"
                          onChange={this.onImageChangeHandler}
                        />
                        <label htmlFor="featureImage">
                          {imageLabel || "Click or drop image to Upload"}
                        </label>
                      </div>
                    </DragImage>
                  </div>
                  {/* <FileUpload onChange={this.onImageChangeHandler} /> */}
                </Col>
                <Col md={12}>
                  {/* job Description Using Draft Editor */}
                  <div className="input-container">
                    <label>
                      Content <span className="required-dot">•</span>
                    </label>

                    <div
                      className={`draft-desc ${
                        error?.emptyFields?.hasOwnProperty("content")
                          ? "emptyInput"
                          : ""
                      }`}
                    >
                      <DraftEditor
                        emptyEditor={this.state.clearInputs}
                        // jobInitialState={this.props.initialData.jobDescription}
                        onChangeHandler={value =>
                          this.handleContentChange(value)
                        }
                      />
                    </div>
                  </div>
                </Col>
                <Col md={3}>
                  <Button
                    onClick={this.onSubmitHandler}
                    color="primary"
                    disabled={loading}
                  >
                    Publish
                  </Button>
                </Col>
                <Col md={3}>
                  <Button
                    onClick={() => this.onSubmitHandler("saveToDraft")}
                    color="primary"
                    outline
                    disabled={loading}
                  >
                    Save to Draft
                  </Button>
                </Col>
                <Col md={3}>
                  <Button
                    onClick={this.toggleModal}
                    color="warning"
                    outline
                    disabled={loading}
                  >
                    Preview
                  </Button>
                </Col>
                <Col md={3}>
                  <Button
                    onClick={() => this.props.onSubmitResource()}
                    disabled={loading}
                  >
                    Cancle
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>
        {/* </Container> */}
      </Col>
    );
  }
}

export default withRouter(AddNewResource);
